module.exports = __webpack_public_path__ + "static/media/buzka-zolta.83ae8ffa.svg";